import { render, staticRenderFns } from "./CreateModelConfiguration.vue?vue&type=template&id=68a8c3a4&scoped=true&"
import script from "./CreateModelConfiguration.vue?vue&type=script&lang=js&"
export * from "./CreateModelConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./CreateModelConfiguration.vue?vue&type=style&index=0&id=68a8c3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a8c3a4",
  null
  
)

export default component.exports